import type { StateProvider, Transition } from "@uirouter/angularjs";
import "angular-local-storage";

export default [
    "localStorageServiceProvider",
    "$stateProvider",
    "TitleProvider",
    (
        localStorageServiceProvider: angular.local.storage.ILocalStorageServiceProvider,
        $stateProvider: StateProvider,
        titleProvider: ng.idle.ITitleProvider,
    ) => {
        localStorageServiceProvider.setPrefix("ir.");

        titleProvider.enabled(false);

        const translateReady = [
            "$translate",
            ($translate: angular.translate.ITranslateService) => $translate.onReady(),
        ];

        const confirmUserVerificationState = {
            component: "irConfirmUserVerification",
            name: "confirmUserVerification",
            ncyBreadcrumb: {
                label: "{{'BeforeLogin.Verification.VerifyUserAccount' | translate}}",
            },
            permission: { allowAnonymous: true },
            resolve: {
                translateReady,
            },
            url: "/users/verification/confirm/:verificationKey",
        };

        const cancelUserVerificationState = {
            component: "irCancelUserVerification",
            name: "cancelUserVerification",
            ncyBreadcrumb: {
                label: "{{'BeforeLogin.Verification.CancelAccountCreation' | translate}}",
            },
            permission: { allowAnonymous: true },
            resolve: {
                translateReady,
            },
            url: "/users/verification/cancel/:verificationKey",
        };

        const requestPasswordResetState = {
            allowAnonymous: true,
            component: "irRequestPasswordReset",
            name: "requestPasswordReset",
            ncyBreadcrumb: {
                label: "{{'BeforeLogin.PasswordReset.PasswordReset' | translate}}",
            },
            permission: { allowAnonymous: true },
            resolve: {
                translateReady,
            },
            url: "/users/passwordReset",
        };

        const confirmPasswordResetState = {
            allowAnonymous: true,
            component: "irConfirmPasswordReset",
            name: "confirmPasswordReset",
            ncyBreadcrumb: {
                label: "{{'BeforeLogin.PasswordReset.ChangePassword' | translate}}",
            },
            permission: { allowAnonymous: true },
            resolve: {
                translateReady,
            },
            url: "/users/passwordReset/confirm/:passwordResetKey",
        };

        const eventDetailsState = {
            allowAnonymous: true,
            component: "irEventDetails",
            name: "eventDetails",
            ncyBreadcrumb: {
                label: " ",
            },
            permission: { allowAnonymous: true },
            resolve: {
                eventId: ["$transition$", ($transition$: Transition) => $transition$.params().eventId],
                translateReady,
            },
            url: "/events/:eventId",
        };

        $stateProvider
            .state(confirmUserVerificationState)
            .state(cancelUserVerificationState)
            .state(requestPasswordResetState)
            .state(confirmPasswordResetState)
            .state(eventDetailsState);
    },
];
